export default __webpack_public_path__ + "static/media/space_object_07-min.26fc29b6.png";